import React, { useState } from "react";
import { motion } from "framer-motion";
import { Copy, Check } from "lucide-react";
import { company, socials } from "../mock";

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(company.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {}
  };

  return (
    <section id="contact" className="relative border-t border-white/5 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="font-display text-xs uppercase tracking-[0.3em] text-[#d4ff4e]"
        >
          (Contact)
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-display mt-6 text-[13vw] font-bold uppercase leading-[0.9] md:text-[9vw]"
        >
          Make it <span className="text-[#d4ff4e]">real.</span>
        </motion.h2>

        <p className="mt-8 max-w-xl text-lg text-[#c9c9c4]">
          You bring the idea. We bring the engineering. Let's see what happens when they meet.
        </p>

        <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
          <button
            onClick={copyEmail}
            className="group inline-flex items-center gap-3 rounded-full border border-white/15 px-6 py-4 text-lg text-white transition-colors hover:border-[#d4ff4e]"
          >
            {company.email}
            {copied ? <Check size={18} className="text-[#d4ff4e]" /> : <Copy size={18} className="text-[#8a8a86] group-hover:text-[#d4ff4e]" />}
          </button>
          <a
            href="#"
            className="inline-flex items-center justify-center rounded-full bg-[#d4ff4e] px-6 py-4 text-lg font-medium text-black transition-transform hover:scale-[1.02]"
          >
            Book a discovery call
          </a>
        </div>

        <div className="mt-16 flex flex-wrap gap-x-8 gap-y-3">
          {socials.map((s) => (
            <a key={s.label} href={s.href} className="link-underline text-sm text-[#c9c9c4] hover:text-white">
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
